export default __webpack_public_path__ + "static/media/deposit.678fdc4e.svg";